import Cookies from 'js-cookie'
import { CookieConsent } from './model/CookieConsent'

const CONSENT_COOKIE_KEY = 'COOKIE_PREFS' // must match in CookieConsentProvider.php
const CONSENT_COOKIE_EXPIRATION_DAYS = 365
const CONSENT_TOKEN_ALL = 'am'
const CONSENT_TOKEN_ANALYTICS_ONLY = 'a'
const CONSENT_TOKEN_MARKETING_ONLY = 'm'
const CONSENT_TOKEN_NONE = 'n'

/**
 * @param {string} cookieValue
 * @return {CookieConsent|null}
 */
function decodeConsentToken(cookieValue) {
  switch (cookieValue) {
    case CONSENT_TOKEN_ALL:
      return CookieConsent.WithFullConsent()
    case CONSENT_TOKEN_ANALYTICS_ONLY:
      return new CookieConsent(true, false)
    case CONSENT_TOKEN_MARKETING_ONLY:
      return new CookieConsent(false, true)
    case CONSENT_TOKEN_NONE:
      return CookieConsent.WithNoConsent()
    default:
      return null
  }
}

/**
 * @param {CookieConsent} consent
 * @return {string}
 */
function encodeConsentToken(consent) {
  if (consent.analytics && consent.marketing) {
    return CONSENT_TOKEN_ALL
  }

  if (consent.analytics) {
    return CONSENT_TOKEN_ANALYTICS_ONLY
  }

  if (consent.marketing) {
    return CONSENT_TOKEN_MARKETING_ONLY
  }

  return CONSENT_TOKEN_NONE
}

/**
 * @return {CookieConsent|null}
 */
function getConsentFromCookie() {
  /**
   * @var {string|undefined} cookieValue
   */
  const cookieValue = Cookies.get(CONSENT_COOKIE_KEY)
  if (!cookieValue) {
    return null
  }

  return decodeConsentToken(cookieValue.trim().toLowerCase())
}

/**
 * @param {CookieConsent} consent
 */
function saveConsentToCookie(consent) {
  const consentToken = encodeConsentToken(consent)
  Cookies.set(CONSENT_COOKIE_KEY, consentToken, { expires: CONSENT_COOKIE_EXPIRATION_DAYS })
}

export { getConsentFromCookie, saveConsentToCookie }
